module.exports = __webpack_public_path__ + "img/diy6.8c19f8f1.png";